/* eslint-disable no-undef */
const DOMElements = {
  body: document.querySelector('body'),
  bottomLinks: document.querySelector('.bottom .links'),
  storeLinks: document.querySelector('.subtitle-container .platform-tabs'),
  storeLinksBottom: document.querySelector('.bottom .platform-tabs'),
};

const createHeader = () => {
  const html = `
		<header>
			<div class="back-link">
				<a href=".."><span>Aplikace</span></a>
			</div>
		</header>
		<div class="top-bar" data-dot="top"></div>
	`;

  return html;
};

const createBottomLinks = (linkError, linkOpinion, linkHelp) => {
  const html = `
		<div class="link error">
			<h4><a href="${linkError}">Nahlásit chybu</a></h4>
			<p>Našli jste chybu v aplikaci? Řekněte nám o ní a my ji co nejdřív odstraníme.</p>
		</div>
		<div class="link opinion">
			<h4><a href="${linkOpinion}">Poslat námět</a></h4>
			<p>Napadá vás, jak aplikaci vylepšit? Napište nám. Nebráníme se ani šíleným nápadům.</p>
		</div>
		<div class="link help">
			<h4><a href="${linkHelp}">Nápověda</a></h4>
			<p>Potřebujete poradit, jak aplikaci používat? Zkuste naši nápovědu.</p>
		</div>
	`;

  return html;
};

// eslint-disable-next-line max-params
const createStoreLinks = (bottom, androidLink, appleLink, windowsLink, huaweiLink, tvLink) => {
  const androidHTML = `
		<li data-id="android" class="android" data-dot="click-to-store-google">
			<a href="${androidLink}">
				<div class="svg-cont">
					<svg width="22px" height="24px" viewBox="0 0 22 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="svg-android" stroke="none" stroke-width="1" fill-rule="evenodd">
							<g transform="translate(-542.000000, -426.000000)">
								<g transform="translate(0.000000, -1.000000)">
									<g transform="translate(509.000000, 416.000000)">
										<g transform="translate(33.500000, 11.000000)">
											<path d="M6,19 L6,22.2 C6,23.1945 6.895,24 8,24 C9.105,24 10,23.1945 10,22.2 L10,19 L11,19 L11,22.2 C11,23.1945 11.895,24 13,24 C14.105,24 15,23.1945 15,22.2 L15,19 L15.1762857,19 C16.1837857,19 17,18.1933333 17,17.1996667 L17,9 L4,9 L4,17.1996667 C4,18.1933333 4.81714286,19 5.82464286,19 L6,19 Z M1.5,17 C0.672,17 0,16.3952 0,15.65 L0,9.35 C0,8.6048 0.672,8 1.5,8 C2.328,8 3,8.6048 3,9.35 L3,15.65 C3,16.3952 2.328,17 1.5,17 Z M19.5,17 C18.672,17 18,16.3952 18,15.65 L18,9.35 C18,8.6048 18.672,8 19.5,8 C20.328,8 21,8.6048 21,9.35 L21,15.65 C21,16.3952 20.328,17 19.5,17 Z" id="Combined-Shape"></path>
											<path d="M8,5 C8.552,5 9,5.448 9,6 C9,6.552 8.552,7 8,7 C7.448,7 7,6.552 7,6 C7,5.448 7.448,5 8,5 M13,5 C13.552,5 14,5.448 14,6 C14,6.552 13.552,7 13,7 C12.448,7 12,6.552 12,6 C12,5.448 12.448,5 13,5 M4,8 L17,8 C17,6.10698859 15.8383571,3.79088914 14.0796429,2.63141965 L15.2078571,0.649436706 C15.3313571,0.420382326 15.2505714,0.180916383 15.0258571,0.054084619 C14.8011429,-0.0727471453 14.5188571,0.0342079992 14.3953571,0.263262379 L13.2634286,2.36071902 C12.424,1.96886566 11.4898571,1.75306236 10.5,1.75306236 C9.45535714,1.75306236 8.47292857,2.00199336 7.59821429,2.43643947 L6.431,0.285978516 C6.30657143,0.0569241361 6.02428571,-0.0254218601 5.79957143,0.101409904 C5.57578571,0.228241668 5.49407143,0.515979402 5.6185,0.745033783 L6.79314286,2.71849817 C5.10592857,3.89027224 4,6.10698859 4,8" id="Fill-11"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>
				</div>
				<div class="txt">
					<span>Stáhnout pro </span>Android
				</div>
			</a>
		</li>
	`;

  const appleHTML = `
		<li data-id="apple" class="apple" data-dot="click-to-store-apple">
			<a href="${appleLink}">
				<div class="svg-cont">
					<svg width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="svg-apple" stroke="none" stroke-width="1" fill-rule="evenodd">
							<g transform="translate(-804.000000, -419.000000)">
								<g transform="translate(0.000000, -1.000000)">
									<g transform="translate(422.000000, 409.000000)">
										<g transform="translate(382.500000, 11.000000)">
											<path d="M15.8695161,12.8933257 C15.843278,9.89621599 18.2852363,8.43856005 18.3965223,8.37054836 C17.0140428,6.321926 14.8697518,6.04160755 14.116988,6.0195497 C12.3156027,5.82746263 10.5694079,7.11417027 9.6519771,7.11417027 C8.716451,7.11417027 7.30411421,6.03793124 5.78230096,6.07009893 C3.82258187,6.10042847 1.99043453,7.25295088 0.985241589,9.04147449 C-1.08938254,12.6892906 0.457764106,18.0502661 2.44553088,20.9986647 C3.43896188,22.4434536 4.60067902,24.0555144 6.1215875,23.9985316 C7.60901972,23.9369535 8.16454489,23.0353391 9.9595969,23.0353391 C11.7383632,23.0353391 12.2604121,23.9985316 13.8111778,23.9626877 C15.4071817,23.9369535 16.4123746,22.5123843 17.3714246,21.0547284 C18.520475,19.3994709 18.9819047,17.7699476 19,17.6863116 C18.9629047,17.6725255 15.8993734,16.4850781 15.8695161,12.8933257" id="Fill-1"></path>
											<path d="M12.7067935,4.16457309 C13.5541983,3.0512016 14.134153,1.53717745 13.9731077,0 C12.7460962,0.0573799048 11.2123318,0.890898521 10.3285,1.98011005 C9.54723879,2.93946179 8.84841738,4.51187251 9.0286347,5.99066339 C10.4071055,6.09837655 11.8220031,5.26083127 12.7067935,4.16457309" id="Fill-4"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>
				</div>
				<div class="txt">
					<span>Stáhnout pro </span>Apple
				</div>
			</a>
		</li>
	`;

  const windowsHTML = `
		<li data-id="windows" class="windows" data-dot="click-to-store-microsoft">
			<a href="${windowsLink}">
				<div class="svg-cont">
					<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="svg-windows" stroke="none" stroke-width="1" fill-rule="evenodd">
							<g transform="translate(-715.000000, -427.000000)">
								<g transform="translate(509.000000, 416.000000)">
									<g transform="translate(206.000000, 11.000000)">
										<polygon id="Fill-1" points="24 0 11 1.84339916 11 11 24 11"></polygon>
										<polygon id="Fill-2" points="0 3.33463152 0 11 9 11 9 2"></polygon>
										<polygon id="Fill-3" points="0 13 0 20.6667324 9 22 9 13"></polygon>
										<polygon id="Fill-4" points="11 13 11 22.158504 24 24 24 13"></polygon>
									</g>
								</g>
							</g>
						</g>
					</svg>
				</div>
				<div class="txt">
					<span>Stáhnout pro </span>Windows
				</div>
			</a>
		</li>
	`;

  const huaweiHTML = `
		<li data-id="huawei" class="huawei" data-dot="click-to-huawei-store">
			<a href="${huaweiLink}">
				<div class="svg-cont">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 80 80">
						<rect
							style="opacity:1;fill-opacity:1;stroke:none;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
							id="svg-huawei"
							width="79.199997"
							height="79.199997"
							x="0.53971732"
							y="0.41223329"
							ry="17.05821" />
						<path
							style="fill:#ffffff;stroke-width:1.07878268"
							d="m 19.756854,7.5248907 c -0.783045,0.04202 -0.743385,1.180905 -0.743385,1.180905 4.208191,8.1949343 11.956813,12.2145273 20.892347,12.2149513 8.923732,-0.01302 16.74923,-4.07695 20.951862,-12.2610733 0,0 0.166594,-1.541107 -1.473514,-1.00693 -4.309914,7.1438013 -11.550732,11.3699843 -19.47307,11.3833033 -7.937347,0.002 -15.152249,-4.179801 -19.4704,-11.3371733 -0.278896,-0.134618 -0.503147,-0.183672 -0.68384,-0.173983 z M 48.237616,39.378914 45.84349,46.509142 43.512876,39.384194 H 41.23778 l 3.67319,10.364525 h 1.771129 l 2.399398,-6.808642 2.396773,6.808642 h 1.785661 l 3.665287,-10.364525 h -2.218212 l -2.334619,7.124948 -2.394104,-7.130228 z m -12.71662,0.0026 -4.645384,10.361891 h 2.183809 l 0.896805,-2.005967 0.06348,-0.151556 h 4.826593 l 0.945755,2.157523 H 42.03537 L 37.43233,39.44214 37.3913,39.38152 Z m 33.642014,0.0013 V 49.73682 h 2.111065 V 39.382885 Z m -60.5288956,0.0013 V 49.752591 H 10.774267 V 45.54175 h 4.830559 v 4.210915 h 2.140168 V 39.384206 h -2.140168 v 4.183231 h -4.830559 v -4.183231 z m 19.0140566,0.0026 v 5.934819 c 0,1.685887 -0.850843,2.585871 -2.396751,2.585871 -1.554607,0 -2.411328,-0.925148 -2.411328,-2.657035 v -5.856924 h -2.138833 v 5.928225 c 0,2.917151 1.649224,4.589177 4.522386,4.589177 2.900445,0 4.563366,-1.7042 4.563366,-4.674841 v -5.849155 z m 31.005843,0.0039 V 49.74468 h 7.96277 v -1.887322 h -5.853017 v -2.567434 h 3.891426 v -1.8885 H 60.763767 V 41.279495 H 66.41308 V 39.39084 Z m -22.22696,2.614853 1.526431,3.471534 0.103164,0.238555 h -3.235375 l 0.101853,-0.238555 z"
							id="path2" />
					</svg>
				</div>
				<div class="txt">
					<span>Objevuj s </span>AppGallery
				</div>
			</a>
		</li>
	`;

  const tvHTML = `
		<li data-id="tv" class="tv" data-dot="click-to-seznamtv">
			<a href="${tvLink}">
				<div class="svg-cont">
					<svg width="24px" height="24px" viewBox="0 0 36 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="svg-tv" stroke="none" stroke-width="1" fill-rule="evenodd">
							<g>
								<path d="M0,0 L36,0 L36,21 L0,21 L0,0 Z M3,3 L33,3 L33,18 L3,18 L3,3 Z" id="Combined-Shape"></path>
								<g transform="translate(7.307692, 5.533333)">
									<rect id="Rectangle" x="5.69230769" y="12.9333333" width="10.3076923" height="4.66666667"></rect>
									<rect id="Rectangle-23-Copy" x="0.692307692" y="16.4666667" width="20" height="3"></rect>
									<polygon id="Triangle-Copy" points="7.69230769 9.46666667 7.69230769 0.466666667 14.6923077 4.96666667"></polygon>
								</g>
							</g>
						</g>
					</svg>
				</div>
				<div class="txt">
					<span>Stáhnout pro </span>TV
				</div>
			</a>
		</li>
	`;

  let html = '';

  if (androidLink) {
    html += androidHTML;
  }
  if (appleLink) {
    html += appleHTML;
  }
  if (windowsLink) {
    html += windowsHTML;
  }
  if (huaweiLink) {
    html += huaweiHTML;
  }
  if (tvLink) {
    html += tvHTML;
  }

  return html;
};

/**
 /=============================================================================
 /
 / Service builder starts here.
 /
 /=============================================================================
 */

// setup classes and title
document.querySelector('#app-content .picture').classList.add(serviceInfo.slug);
document.querySelector('.swiper-slide .detail').classList.add(serviceInfo.slug);
document.querySelector('.title h1').classList.add(serviceInfo.slug);
document.querySelector('.title h1').textContent = serviceInfo.title;
document.querySelector('.title .subtitle').textContent = serviceInfo.subtitle;

// header
DOMElements.body.insertAdjacentHTML('afterbegin', createHeader());

// style tabs
var links = document.querySelector('.subtitle-container .platform-tabs');
if (links) {
  links.style.visibility = 'hidden';
}

// bottom links
DOMElements.bottomLinks.insertAdjacentHTML('afterbegin', createBottomLinks(serviceInfo.links.error, serviceInfo.links.opinion, serviceInfo.links.help));

// platform tabs
DOMElements.storeLinks.insertAdjacentHTML(
  'afterbegin',
  createStoreLinks(false, serviceInfo.links.android, serviceInfo.links.apple, serviceInfo.links.windows, serviceInfo.links.huawei, serviceInfo.links.tv)
);
DOMElements.storeLinksBottom.insertAdjacentHTML(
  'afterbegin',
  createStoreLinks(true, serviceInfo.links.android, serviceInfo.links.apple, serviceInfo.links.windows, serviceInfo.links.huawei, serviceInfo.links.tv)
);

// footer date
var d = new Date();
document.querySelector('.current-year').textContent = d.getFullYear();
